export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";